// 统一埋点工具
// 支持热云(Solar)、Singular、FB Pixel

// 热云配置
const SOLAR_USER_CODE = '8ee20340115e6cce'; // 用户的userCode
const SOLAR_APP_KEY = '9593e8ecdfef41d4'; // 应用的appKey

// Singular配置
const SINGULAR_PRODUCT_ID = 'Novel_Course_1204'; // Product ID (Bundle ID)
const SINGULAR_SDK_KEY = 'beast_aura_boom_28cab375'; // SDK Key
const SINGULAR_SDK_SECRET = '3f7358f81e0a16163877fcf77324190a'; // SDK Secret

// FB Pixel配置
const FB_PIXEL_ID = '1871700513551023';

// 初始化所有SDK
export const initAnalytics = () => {
  if (typeof window === 'undefined') return;

  // 初始化 FB Pixel
  initFBPixel();

  // 初始化 Singular
  initSingular();

  // 初始化热云
  initSolar();
};

// 初始化 FB Pixel
const initFBPixel = () => {
  if (typeof window.fbq !== 'undefined') return;

  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', FB_PIXEL_ID);
  window.fbq('track', 'page_view');
};

// 初始化 Singular
const initSingular = () => {
  // 加载 SDK 脚本
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://web-sdk-cdn.singular.net/singular-sdk/latest/singular-sdk.js';
  script.onload = function () {
    if (window.singularSdk && window.SingularConfig) {
      try {
        // 使用官方 SingularConfig 方式初始化
        var config = new window.SingularConfig(SINGULAR_SDK_KEY, SINGULAR_SDK_SECRET, SINGULAR_PRODUCT_ID);
        window.singularSdk.init(config);

        console.log('Singular SDK 初始化成功');
      } catch (e) {
        console.error('Singular SDK 初始化失败:', e);
      }
    }
  };
  script.onerror = function () {
    console.error('Singular SDK 加载失败');
  };
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
};

// 初始化热云
const initSolar = () => {
  if (typeof window.SESDK !== 'undefined') return;

  // 加载热云SDK (需要下载SDK文件到public目录)
  // 下载地址: https://sdk.solar-engine.com/Web/SolarEngine-Web-CN-SDK-1.3.0.zip
  const script = document.createElement('script');
  script.async = true;
  script.src = '/solar-sdk/web-us-sesdk-umd.js'; // 将下载的SDK文件放到public/solar-sdk/目录
  script.onload = () => {
    if (window.SESDK) {
      try {
        // 预初始化
        window.SESDK.prevInit(SOLAR_APP_KEY);
        // 初始化
        window.SESDK.init({
          appKey: SOLAR_APP_KEY,
          userId: SOLAR_USER_CODE,
          config: {
            logEnabled: true
            //debugModel: true // 开启调试模式，输出更详细的日志
          }
        });
        console.log('热云SDK初始化成功');
      } catch (e) {
        console.error('热云SDK初始化失败:', e);
      }
    }
  };
  script.onerror = () => {
    console.error('热云SDK加载失败，请下载SDK文件并放到 public/solar-sdk/ 目录');
  };
  document.head.appendChild(script);
};

// 统一上报事件（内部方法，不直接使用）
const trackEventInternal = (fbEventName, singularEventName, solarEventName, params = {}) => {
  if (typeof window === 'undefined') return;

  // FB Pixel（严格按官方标准事件映射）
  if (fbEventName && typeof window.fbq !== 'undefined') {
    switch (fbEventName) {
      case 'page_view':
        window.fbq('track', 'page_view');
        break;
      case 'view_content':
        window.fbq('track', 'view_content');
        break;
      case 'complete_registration':
        window.fbq('track', 'complete_registration');
        break;
      case 'add_payment_info':
        window.fbq('track', 'add_payment_info');
        break;
      case 'initiate_checkout':
        window.fbq('track', 'initiate_checkout');
        break;
      case 'purchase':
        window.fbq('track', 'purchase', params);
        break;
      default:
        window.fbq('trackCustom', fbEventName, params);
    }
  }

  // Singular
  if (
    singularEventName &&
    typeof window !== 'undefined' &&
    window.singularSdk &&
    typeof window.singularSdk.event === 'function'
  ) {
    window.singularSdk.event(singularEventName, params);
  }

  // 热云（使用小写事件名）
  if (solarEventName && typeof window.SESDK !== 'undefined') {
    window.SESDK.track(solarEventName, params);
  }
};

// 兼容旧的 trackEvent 方法（仅用于通用事件）
export const trackEvent = (eventName, params = {}) => {
  trackEventInternal(
    eventName,
    eventName,
    eventName
      .toLowerCase()
      .replace(/([A-Z])/g, '_$1')
      .replace(/^_/, '')
      .replace(/__+/g, '_'),
    params
  );
};

// 标准FB Pixel事件业务埋点
export const trackViewContent = () => {
  trackEventInternal('view_content', 'ViewContent', 'view_content');
};

export const trackCompleteRegistration = () => {
  trackEventInternal('complete_registration', 'CompleteRegistration', 'complete_registration');
};

export const trackAddPaymentInfo = () => {
  trackEventInternal('add_payment_info', 'AddPaymentInfo', 'add_payment_info');
};

export const trackInitiateCheckoutFB = () => {
  trackEventInternal('initiate_checkout', 'InitiateCheckout', 'initiate_checkout');
};

export const trackPurchaseFB = (value = 0, currency = 'USD') => {
  trackEventInternal('purchase', 'Purchase', 'purchase', { value, currency });
};

// 页面浏览埋点（兼容原有逻辑）
export const trackPageView = () => {
  trackEventInternal('page_view', 'PageView', 'page_view');

  // Singular pageVisit
  if (typeof window !== 'undefined' && window.singularSdk && typeof window.singularSdk.pageVisit === 'function') {
    window.singularSdk.pageVisit();
  }
};

// 页面进度埋点
export const trackPageProgress = (progress) => {
  trackEvent(`page_progress_${progress}`);
};

// 点击CTA按钮
export const trackClickCTA = () => {
  trackEvent('click_cta');
};

// 邮箱信息填写
export const trackAddEmailInfo = (email) => {
  trackEvent('add_email_info', { email });
};

// 点击支付按钮
export const trackInitiateCheckout = (params) => {
  trackEvent('initiate_checkout', params);
};

// 跳转到收银台
export const trackCheckoutPage = () => {
  trackEvent('checkout_page');
};

// 支付成功
export const trackPurchase = (params) => {
  trackEvent('purchase', {
    value: params.value || 0,
    currency: params.currency || 'USD',
    ...params
  });
};

// 订阅成功
export const trackSubscribe = (params) => {
  trackEvent('subscribe', params);
};

// 续订成功
export const trackSubscriptionRenewSuccess = (params) => {
  trackEvent('subscription_renew_success', params);
};
